import React from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";

const ChangePage = () => {
  return (
    <>
      <Navbar bg="transparent" expand="lg" variant="dark">
        <Container>
          <Navbar.Brand href="/">E</Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link href="/about.js">About</Nav.Link>
              <Nav.Link href="/experience.js">Experience</Nav.Link>
              <Nav.Link href="/work.js">Work</Nav.Link>
            </Nav>
            <Nav>
              <Button href="/contact.js" variant="outline-primary">
                Contact Me
              </Button>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default ChangePage;
